import { createAction } from '@reduxjs/toolkit'
import { type FetchUserFailurePayload, type FetchUserSuccessPayload, type LockSuccessPayload } from './auth-types'

/* Action Types */

const FETCHING_USER_INFORMATION = 'FETCHING_USER_INFORMATION'
const LOCK_SUCCESS = 'LOCK_SUCCESS'
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
const USER_RECEIVED = 'USER_RECEIVED'
const USER_RECEIVED_FAILURE = 'USER_RECEIVED_FAILURE'

/* Action Creators */

export const LockSuccessAction = createAction<LockSuccessPayload>(LOCK_SUCCESS)
export const LogoutSuccessAction = createAction(LOGOUT_SUCCESS)
export const FetchingUserInformationAction = createAction(FETCHING_USER_INFORMATION)
export const UserReceivedAction = createAction<FetchUserSuccessPayload>(USER_RECEIVED)
export const UserReceivedFailureAction = createAction<FetchUserFailurePayload>(USER_RECEIVED_FAILURE)
